<template>
	<b-modal
		ref="modal-changePlatform"
		id="change-sass-modal"
		:title="$t('global.changePlatform')"
		title-class="text-muted"
		hide-footer
	>
		<b-alert v-if="countAll === 1" show variant="warning">{{ $t('accessDenied.onlyOneAccess') }}</b-alert>

		<!-- selects view -->
		<b-form v-if="countAll >= 10" @submit="doChangePlatform">
			<b-form-group label-size="sm" label-class="text-muted" :label="$t('global.selectOption')" class="mb-3">
				<b-form-select v-model="systemSelected" @change="fillSassSelected($event)" class="mt-2">
					<b-form-select-option :value="null" disabled>{{$t('global.selectOption')}}</b-form-select-option>
					<b-form-select-option v-if="loadSuppliers" value="supplier">{{$t('global.supplier')}}</b-form-select-option>
					<b-form-select-option v-if="loadPos" value="pos">{{$t('global.pointOfSale')}}</b-form-select-option>
				</b-form-select>
			</b-form-group>

			<b-form-group label-size="sm" label-class="text-muted" :label="systemSelectedMsg" class="mb-4">
				<b-form-select v-model="sassReferenceId" :options="sassOpts" class="mt-2" required/>
			</b-form-group>

			<div class="text-center">
				<b-button variant="primary" block type="submit">{{ $t('global.change') }}</b-button>
			</div>
		</b-form>

		<!-- buttons view -->
		<b-row v-if="countAll > 1 && countAll < 10" class="pb-3">
			<!-- pos -->
			<b-col cols="12" v-if="loadPos && Object.keys(pos).length > 0">
				<h4>{{$t('global.pointOfSale')}}</h4>

				<b-button
					v-for="(item,i) in pos"
					:key="i"
					variant="info"
					class="mr-2 my-1"
					size="sm"
					v-b-tooltip.hover v-b-tooltip.placement.auto
					:title="$t('global.clicToSwitch') + ' ' + $t('global.pointOfSale')"
					@click="goToPlatform('pos', item.value)"
				>
					{{ item.text }}
				</b-button>

				<hr v-if="loadSuppliers" class="my-4">
			</b-col>

			<!-- suppliers -->
			<b-col cols="12" v-if="loadSuppliers">
				<h4>{{$t('global.supplier')}}</h4>
				<b-button
					v-for="(item,i) in $root.auxVars.userSuppliersAccess"
					:key="i"
					variant="warning"
					class="mr-2 my-1"
					size="sm"
					v-b-tooltip.hover v-b-tooltip.placement.auto
					:title="$t('global.clicToSwitch') + ' ' + $t('global.supplier')"
					@click="goToPlatform('supplier', item.value)"
				>
					{{ item.text }}
				</b-button>
			</b-col>
		</b-row>

	</b-modal>
</template>

<script>
import chatProvider from "@/components/helpers/helpers-chat";
export default {
	components: {},
	data() {
		return {
			isActive: false,
			sassReferenceId: null,
			systemSelected: null,
			sassOpts: [],
			pos: [],
			systemSelectedMsg: this.$t('global.changeOf', {system: ''}),
		}
	},
	methods: {
		loadModel() {
			this.pos = this.$root.auxVars.userPointOfSalesAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
			this.$refs["modal-changePlatform"].show();
		},

		// logic --
		fillSassSelected() {
			if (this.systemSelected === 'supplier') {
				this.sassOpts = this.$root.auxVars.userSuppliersAccess
				this.systemSelectedMsg = this.$t('global.changeOf', {system: this.$t('global.supplier')})
			} else if (this.systemSelected === 'pos') {
				this.systemSelectedMsg = this.$t('global.changeOf', {system: this.$t('global.pointOfSale')})
				this.sassOpts = this.$root.auxVars.userPointOfSalesAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id)
			}
		},

		_process(type, referenceId) {
			this.$root.showWarning({
				message: this.$t('warnings.switchSystem'),
				okAction: (event, setLoading, close) => {
					setLoading(true)

					switch (type) {
						case 'pos':
							this.$root.api.post('/auth/system', null, {
								headers: {
									"X-SC-TYPE": 'pos',
									"X-SC-SYSTEM": referenceId,
								}
							}).then((response) => {
								this.$root.store.setSystemData(response.data)

								if(this.$route.path === '/')
									location.reload()
								else
									this.$router.push('/')

								setLoading(false)
							}).catch((err) => {
								this.$root.handleRequestError(err)
								close()
							})
							break;
						case 'supplier':
							window.location = process.env.VUE_APP_SUPPLIERS + '/login?referenceId=' + referenceId + '&token=' + this.$root.store.state.currentToken
							setLoading(false)
							this.$root.auxVars.clearResources();
							this.$root.store.clearUser();
							if (this.$root.chatStarted) {
								chatProvider.shutdown();
								this.$root.chatStarted = false;
							}
							break;
						default:
							this.$root.showAlert(this.$t('warnings.selectValidSystem'), {variant: 'danger'})
							break;
					}
				}
			})
		},

		// event for select view
		doChangePlatform(evt) {
			evt.preventDefault();
			this._process(this.systemSelected, this.sassReferenceId)
		},

		// event for btns view
		goToPlatform(type, reference) {
			this._process(type, reference)
		}
	},
	mounted(){
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['userListSassAccess']})
	},
	computed: {
		countAll() {
			let pos = this.$root.auxVars.userPointOfSalesAccess
			let sup = this.$root.auxVars.userSuppliersAccess

			let total = 0
			if(typeof sup != 'undefined')
				total = parseInt(pos.length) + parseInt(sup.length)
			else
				total = parseInt(pos.length)

			return total;
		},
		loadSuppliers() {
			return typeof this.$root.auxVars.userSuppliersAccess != 'undefined';
		},
		loadPos() {
			return typeof this.$root.auxVars.userPointOfSalesAccess != 'undefined';
		}
	}
}
</script>



















